export default __webpack_public_path__ + "static/media/JobOne1.f1bf75d5.JPG";